import { EYE_REPAIR_V31 } from "@/data/eyeRepairV31";

// PDP3.2 — exact duplicate of PDP3.1, only the `v32` scope flag differs so
// the scoped CSS in index.css re-skins the two brand colours (#0F2E2E ->
// #003D4C, #D2E0E0 -> #A4C9D2 @ 50%). All content/layout is identical.
export const EYE_REPAIR_V32 = { ...EYE_REPAIR_V31, v32: true };

export default EYE_REPAIR_V32;
